import { render, staticRenderFns } from "./agentlogin.vue?vue&type=template&id=ebabe660"
import script from "./agentlogin.vue?vue&type=script&lang=js"
export * from "./agentlogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports